import axios from 'axios'
import React, { useContext, useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import moment from 'moment';

import authContext from '../context/authContext/authContext';
import AddPropdesk from '../components/modals/AddPropdesk';
import AddStock from '../components/modals/AddStock';
import EditStock from '../components/modals/EditStock';
import errorHandle from '../utils/errorHandle';

const GET_STOCK_API_END_POINT = process.env.REACT_APP_API_URL + "/api/admin/getStock";
const DELETE_STOCK_API_END_POINT = process.env.REACT_APP_API_URL + "/api/admin/deleteStock";

const Stock = () => {
  const { getConfig } = useContext(authContext);
  const config = getConfig();

  const intialState = { loading: false, stock: null }
  const [state, setCompleteState] = useState(intialState)
  const setState = (newState) => setCompleteState((prevState) => ({ ...prevState, ...newState }))

  const getStock = async () => {
    setState({ loading: true })
    await axios.get(GET_STOCK_API_END_POINT, config)
      .then((res) => setState({ stock: res?.data?.stock, loading: false }))
      .catch((err) => {
        setState({ loading: false })
        errorHandle(err)
      })
  }

  const deleteStock = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      showCancelButton: true,
      reverseButtons: true // 👈 this does the trick
    }).then((result) => {
      if (result.isConfirmed) {
        confirmDeleteStock(state?.stock?._id);
      }
    });
  }

  const confirmDeleteStock = async (id) => {
    setState({ loading: true })
    const data = { id }
    await axios.post(DELETE_STOCK_API_END_POINT, data, config)
      .then((res) => {
        setState({ loading: false })
        toast.success(res?.data?.message, { position: 'bottom-right' });
        getStock();
      })
      .catch((err) => {
        setState({ loading: false })
        errorHandle(err)
      })
  }

  useEffect(() => {
    getStock();
  }, []);

  return (
    <div className='main-container pb-1'>
      <div className="card-box mb-30">
        <div className='table-card-header'>
          <div className='d-flex align-items-center'>
            <h2 className="h4 mb-0 py-2">Stock Of the Month</h2>
            {state.loading ? (
              <div className='ml-3'>
                <div className="spinner-border spinner-border-sm text-primary" role="status" />
              </div>
            ) : null}
          </div>
          <div className='actions-container'>
            {!state?.stock ? (
              <button className='btn gleamdesk-blue' onClick={() => setState({ openAddStockModal: true })} disabled={state.loading}>
                <i className='fa fa-plus mr-1' />
                <span>Add Stock</span>
              </button>
            ) : null}

            {state?.stock ? (
              <button className='btn gleamdesk-orange' onClick={() => setState({ openEditStockModal: true })} disabled={state.loading}>
                <i className='fa fa-pencil mr-1' />
                <span>Edit Stock</span>
              </button>
            ) : null}

            {state?.stock ? (
              <button className='btn btn-danger' onClick={deleteStock} disabled={state.loading}>
                <i className='fa fa-trash mr-1' />
                <span>Delete Stock</span>
              </button>
            ) : null}
          </div>
        </div>
      </div>

      {state?.stock ? (
        <div className='card-box pd-20 mb-30'>
          <div className='text-center fs-24 mb-4'><strong>{state?.stock?.name}</strong></div>
          <div className='row align-items-center'>
            <div className='col-lg-5 col-md-6 text-center mb-4 mb-md-0'>
              <img src={state?.stock?.image} className='img-stock img-fluid' alt={state?.stock?.name || "Stock of the month"} />
            </div>

            <div className='col-lg-7 col-md-6'>
              <div className="stock-content" dangerouslySetInnerHTML={{ __html: state?.stock?.content || '' }} />
            </div>
          </div>
        </div>
      ) : (
        <div className='card-box pd-20 text-center text-muted'>
          No stock of the month available
        </div>
      )}

      <AddStock
        isOpen={state?.openAddStockModal}
        toggle={() => setState({ openAddStockModal: false })}
        getStock={getStock}
      />

      <EditStock
        isOpen={state?.openEditStockModal}
        toggle={() => setState({ openEditStockModal: false })}
        stockId={state?.stock?._id}
        stock={state?.stock}
        getStock={getStock}
      />
    </div>
  )
}

export default Stock;